import React, { useEffect, useState } from 'react';
const purchases = [{
  name: 'Marco R.',
  location: 'Milano, Italia'
}, {
  name: 'Giulia S.',
  location: 'Roma, Italia'
}, {
  name: 'Luca T.',
  location: 'Torino, Italia'
}, {
  name: 'Francesca L.',
  location: 'Napoli, Italia'
}, {
  name: 'Matteo K.',
  location: 'Bologna, Italia'
}, {
  name: 'Roberto B.',
  location: 'Firenze, Italia'
}, {
  name: 'Maria P.',
  location: 'Palermo, Italia'
}, {
  name: 'Giacomo W.',
  location: 'Venezia, Italia'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 right-4 z-50 flex justify-center pointer-events-none" data-id="element-155">
      <div className="bg-[#FFFBEA] border-2 border-[#EAB308] p-3 max-w-[320px] w-full relative pointer-events-auto shadow-lg" data-id="element-156">
        <button onClick={() => setVisible(false)} className="absolute top-1 right-2 text-graphite font-bold text-lg" data-id="element-157">
          ×
        </button>
        <div className="leading-tight pr-4" data-id="element-158">
          <p className="font-bold text-petrol text-sm font-body" data-id="element-159">
            {currentPurchase.name}
          </p>
          <p className="text-xs text-graphite font-medium" data-id="element-160">
            da {currentPurchase.location}
          </p>
          <p className="text-xs text-[#D97706] font-bold mt-1 font-body" data-id="element-161">
            Ha appena acquistato il libro digitale!
          </p>
        </div>
      </div>
    </div>;
}